module.exports = __webpack_public_path__ + "static/media/leafCover.e81adb81.svg";